import { FormItem } from '../../../../../../commons/Form/Form.types';
import { DashboardCompaniesFiltersFormSchema } from './DashboardCompaniesFiltersForm.types';

export const dashboardCompaniesFiltersFormData: FormItem<DashboardCompaniesFiltersFormSchema>[][] =
  [
    // [
    //   {
    //     name: 'domains',
    //     placeholder: "Catégories d'activité de la consultation...",
    //     label: "Catégories d'activité",
    //     type: 'select',
    //     id: 'categories',
    //     options: [
    //       {
    //         value: '1',
    //         label: 'Travaux de bâtiment',
    //       },
    //       {
    //         value: '2',
    //         label: 'Travaux Publics',
    //       },
    //       {
    //         value: '3',
    //         label: 'Fournitures',
    //       },
    //       {
    //         value: '4',
    //         label: 'Services',
    //       },
    //     ],
    //   },
    // ],
    [
      {
        name: 'fieldsOfActivity',
        placeholder: "Domaine d'activité de la consultation...",
        label: "Domaine d'activité",
        type: 'select',
        id: 'field-of-activity',
      },
    ],
    [
      {
        name: 'region',
        placeholder: 'Filtrer par région...',
        label: 'Région',
        type: 'select',
        id: 'region',
      },
    ],
    [
      {
        name: 'department',
        placeholder: 'Filtrer par département...',
        label: 'Département',
        type: 'select',
        id: 'department',
      },
    ],
  ];
